import React from 'react';
import { Link } from 'react-router-dom';
import { useContact } from '../contexts/ContactContext';

const Footer = ({ isDashboard = false }) => {
  const { openContact } = useContact();

  return (
    <>
      <style jsx>{`
        @media (max-width: 767px) {
          .footer-main-wrapper {
            flex-direction: column !important;
            align-items: center !important;
            padding-bottom: 90px !important;
          }
          .footer-main-wrapper.dashboard-footer {
            padding-bottom: 110px !important;
          }
          .footer-container {
            flex-direction: column !important;
            gap: 12px !important;
            align-items: center !important;
          }
          .footer-link {
            margin-right: 0 !important;
            display: block !important;
          }
          .footer-text {
            display: block !important;
            text-align: center !important;
          }
          .footer-feedback-text {
            display: block !important;
            margin-top: 4px !important;
            margin-left: 0 !important;
          }
          .mobile-hide {
            display: none !important;
          }
          .social-links {
            flex-direction: column !important;
            gap: 12px !important;
            align-items: center !important;
            margin-top: 12px !important;
          }
          .desktop-spacer {
            display: none !important;
          }
        }
      `}</style>
      {/* Footer content */}
      <div className="bg-gray-100 px-4 shadow-sm text-sm" style={{ position: 'static', zIndex: 'auto', marginTop: '0.5rem' }}>
        {/* Gray line above footer - matching navbar spacing */}
        <div style={{ 
          height: '2px', 
          backgroundColor: '#4A5759', 
          margin: '0 10%', 
          position: 'relative',
          zIndex: 1
        }}></div>
        
        <div className={`footer-main-wrapper ${isDashboard ? 'dashboard-footer' : ''}`} style={{ position: 'relative', paddingTop: '0.25rem', paddingBottom: '0rem' }}>
          {/* First Row: Footer links */}
          <div className="flex flex-col md:flex-row justify-between items-center w-full" style={{ marginBottom: '0.5rem' }}>
            
            {/* LEFT: Spacer - only on desktop */}
            <div className="hidden md:block desktop-spacer" style={{ width: '200px' }}></div>

            {/* CENTER: Footer links */}
            <div className="flex items-center footer-container">
              <Link 
                to="/policies" 
                style={{ color: '#5A9ECB', marginRight: '2.5rem', fontSize: '1rem', textDecoration: 'none' }} 
                className="text-sm md:text-lg hover:underline footer-link"
              >
                Terms and Policies
              </Link>
              <Link 
                to="/trade-guitar-pedals" 
                style={{ color: '#5A9ECB', marginRight: '2.5rem', fontSize: '1rem', textDecoration: 'none' }} 
                className="text-sm md:text-lg hover:underline footer-link"
              >
                How to Trade Pedals
              </Link>
              <span style={{ color: '#6B7280', fontSize: '1rem' }} className="footer-text">
                <span className="mobile-hide">Need help or found a bug?{' '}</span>
                <button 
                  onClick={() => openContact({ category: 'general' })}
                  className="hover:underline"
                  style={{ 
                    color: '#5A9ECB',
                    background: 'none',
                    border: 'none',
                    padding: 0,
                    font: 'inherit',
                    cursor: 'pointer',
                    textDecoration: 'none'
                  }}
                >
                  Contact PXC Support
                </button>
              </span>
              <span style={{ color: '#6B7280', fontSize: '1rem', marginLeft: '2.5rem' }} className="footer-text footer-feedback-text">
                <span className="mobile-hide">Help us improve.{' '}</span>
                <button
                  onClick={() => openContact({ category: 'feedback' })}
                  className="hover:underline"
                  style={{
                    color: '#5A9ECB',
                    background: 'none',
                    border: 'none',
                    padding: 0,
                    font: 'inherit',
                    cursor: 'pointer',
                    textDecoration: 'none'
                  }}
                >
                  Share feedback
                </button>
              </span>
            </div>

            {/* RIGHT: Spacer - only on desktop */}
            <div className="hidden md:block desktop-spacer" style={{ width: '200px' }}></div>
          </div>
          
          {/* Second Row: Social media links */}
          <div className="flex flex-col md:flex-row justify-between items-center w-full">
            
            {/* LEFT: Spacer - only on desktop */}
            <div className="hidden md:block desktop-spacer" style={{ width: '200px' }}></div>

            {/* CENTER: Social links */}
            <div className="flex items-center social-links">
              <a 
                href="https://www.youtube.com/@pedalxchange" 
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#5A9ECB', marginRight: '2.5rem', fontSize: '1rem', textDecoration: 'none' }} 
                className="text-sm md:text-lg hover:underline footer-link"
              >
                YouTube
              </a>
              <a 
                href="https://www.instagram.com/pedal_x_change/" 
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#5A9ECB', marginRight: '2.5rem', fontSize: '1rem', textDecoration: 'none' }} 
                className="text-sm md:text-lg hover:underline footer-link"
              >
                Instagram
              </a>
              <a 
                href="https://www.facebook.com/profile.php?id=61584573345636" 
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#5A9ECB', fontSize: '1rem', textDecoration: 'none' }} 
                className="text-sm md:text-lg hover:underline footer-link"
              >
                Facebook
              </a>
            </div>

            {/* RIGHT: Spacer - only on desktop */}
            <div className="hidden md:block desktop-spacer" style={{ width: '200px' }}></div>
          </div>
        </div>
      </div>

      {/* White band at bottom */}
      <div className="bg-white" style={{ height: '20px' }}></div>
    </>
  );
};

export default Footer;
